import './$layout.svelte.css.proxy.js';
/* src/routes/$layout.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	component_subscribe,
	create_component,
	create_slot,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	query_selector_all,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	update_slot
} from "../../_snowpack/pkg/svelte/internal.js";

import Header from "../../_components/layout/Header.svelte.js";
import Footer from "../../_components/layout/Footer.svelte.js";
import { loading } from "../../_components/page/index.js";

function create_if_block(ctx) {
	let div;
	let span;

	return {
		c() {
			div = element("div");
			span = element("span");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			span = claim_element(div_nodes, "SPAN", {});
			children(span).forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "loading");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, span);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function create_fragment(ctx) {
	let meta0;
	let meta1;
	let meta2;
	let meta3;
	let t0;
	let t1;
	let div0;
	let header;
	let t2;
	let main;
	let t3;
	let div1;
	let footer;
	let current;
	let if_block = /*$loading*/ ctx[0] && create_if_block(ctx);
	header = new Header({});
	const default_slot_template = /*#slots*/ ctx[2].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[1], null);
	footer = new Footer({});

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			t0 = space();
			if (if_block) if_block.c();
			t1 = space();
			div0 = element("div");
			create_component(header.$$.fragment);
			t2 = space();
			main = element("main");
			if (default_slot) default_slot.c();
			t3 = space();
			div1 = element("div");
			create_component(footer.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-4bcshh\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { property: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { name: true, content: true });
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			if (if_block) if_block.l(nodes);
			t1 = claim_space(nodes);
			div0 = claim_element(nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			claim_component(header.$$.fragment, div0_nodes);
			div0_nodes.forEach(detach);
			t2 = claim_space(nodes);
			main = claim_element(nodes, "MAIN", {});
			var main_nodes = children(main);
			if (default_slot) default_slot.l(main_nodes);
			main_nodes.forEach(detach);
			t3 = claim_space(nodes);
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			claim_component(footer.$$.fragment, div1_nodes);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(meta0, "property", "og:image");
			attr(meta0, "content", "/images/index-heading-1.png");
			attr(meta1, "property", "og:site_name");
			attr(meta1, "content", "協和自動車有限会社");
			attr(meta2, "property", "og:locale");
			attr(meta2, "content", "ja_JP");
			attr(meta3, "name", "twitter:card");
			attr(meta3, "content", "summary");
			attr(div0, "class", "header");
			attr(div1, "class", "footer");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			insert(target, t0, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, t1, anchor);
			insert(target, div0, anchor);
			mount_component(header, div0, null);
			insert(target, t2, anchor);
			insert(target, main, anchor);

			if (default_slot) {
				default_slot.m(main, null);
			}

			insert(target, t3, anchor);
			insert(target, div1, anchor);
			mount_component(footer, div1, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*$loading*/ ctx[0]) {
				if (if_block) {
					
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(t1.parentNode, t1);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 2) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[1], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(default_slot, local);
			transition_in(footer.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			transition_out(default_slot, local);
			transition_out(footer.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			if (detaching) detach(t0);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t1);
			if (detaching) detach(div0);
			destroy_component(header);
			if (detaching) detach(t2);
			if (detaching) detach(main);
			if (default_slot) default_slot.d(detaching);
			if (detaching) detach(t3);
			if (detaching) detach(div1);
			destroy_component(footer);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $loading;
	component_subscribe($$self, loading, $$value => $$invalidate(0, $loading = $$value));
	let { $$slots: slots = {}, $$scope } = $$props;

	$$self.$$set = $$props => {
		if ("$$scope" in $$props) $$invalidate(1, $$scope = $$props.$$scope);
	};

	return [$loading, $$scope, slots];
}

class $layout extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default $layout;
//# sourceMappingURL=$layout.svelte.js.map
